export const projectKeys = {
  all: ["projects"] as const,
  list: (filters: Record<string, string | undefined> = {}) => [...projectKeys.all, "list", filters] as const,
  detail: (id: string) => [...projectKeys.all, "detail", id] as const,
};

export const epicKeys = {
  all: ["epics"] as const,
  list: (projectId: string) => [...epicKeys.all, "list", projectId] as const,
};

export const sprintKeys = {
  all: ["sprints"] as const,
  list: (status?: string) => [...sprintKeys.all, "list", status] as const,
  tasks: (id: string) => [...sprintKeys.all, "tasks", id] as const,
};

export const taskKeys = {
  all: ["tasks"] as const,
  list: (filters: Record<string, string | undefined>) => [...taskKeys.all, "list", filters] as const,
  detail: (id: string) => [...taskKeys.all, "detail", id] as const,
};

export const userKeys = {
  all: ["users"] as const,
  list: () => [...userKeys.all, "list"] as const,
  directory: () => [...userKeys.all, "directory"] as const,
};

export const timeEntryKeys = {
  all: ["timeEntries"] as const,
  list: (filters: Record<string, string | undefined>) => [...timeEntryKeys.all, "list", filters] as const,
};

export const reportKeys = {
  all: ["reports"] as const,
  byProject: (projectId: string, from: string, to: string) => [...reportKeys.all, "by-project", projectId, from, to] as const,
  byUser: (userId: string, from: string, to: string) => [...reportKeys.all, "by-user", userId, from, to] as const,
  timeline: (scope: string, scopeId: string, from: string, to: string, granularity: string) =>
    [...reportKeys.all, "timeline", scope, scopeId, from, to, granularity] as const,
  velocity: (projectId: string) => [...reportKeys.all, "velocity", projectId] as const,
  overview: () => [...reportKeys.all, "overview"] as const,
  byAssignee: (from: string, to: string) => [...reportKeys.all, "by-assignee", from, to] as const,
  tasksByProject: () => [...reportKeys.all, "tasks-by-project"] as const,
  ticketResponse: (from: string, to: string) => [...reportKeys.all, "ticket-response", from, to] as const,
  gantt: () => [...reportKeys.all, "gantt"] as const,
  activity: (from: string, to: string, granularity: string) => [...reportKeys.all, "activity", from, to, granularity] as const,
};

export const ticketKeys = {
  all: ["tickets"] as const,
  list: (filters: Record<string, string | undefined>) => [...ticketKeys.all, "list", filters] as const,
  detail: (id: string) => [...ticketKeys.all, "detail", id] as const,
};

export const settingsKeys = {
  all: ["settings"] as const,
  sla: () => [...settingsKeys.all, "sla"] as const,
};
